<template>
    <div v-if="loading" class="flex justify-center mb-64 mt-32">
        <loading-spinner/>
    </div>
    <component
        v-else
        :is="display"
        v-bind="props"
    />
    <Meta title="Catalog | Resources" :jsonLdBreadcrumbs="crumbs" description="View a complete list of our vast collection of resources by manufacturer." />
</template>

<script setup>
import {useSettingsLoader, useUser} from "@/Composables";
import {LoadingSpinner, Meta} from "@/Components";
import MarketingIndex from "@/Themes/Marketing/Pages/Catalog/Resources/Index.vue";
import SourcingIndex from "@/Themes/Sourcing/Pages/Catalog/Resources/Index.vue";
import {ref, computed, onMounted, markRaw} from "vue";

const { settings } = useUser();
const props = defineProps({
    crumbs: {
        type: Array,
        required: true,
    },
    manufacturers: {
        type: Array,
        required: true,
    },
    newCatalogs: {
        type: Array,
        required: true,
    },
    newVideos: {
        type: Array,
        required: true,
    },
    pinnedResources: {
        type: Array,
        required: false,
    },
});

const loading = ref(true);

onMounted(() => {
    try{
        useSettingsLoader().fetchSettings(['resourceSearch']).then(()=> {
            loading.value = false;
        });
    }catch (e) {
        console.log(e);
    }
});

const display = computed(() =>
    settings.value.is_sourcing_mode ? markRaw(SourcingIndex) : markRaw(MarketingIndex)
);
</script>
